<template>
  <div class="home mt-3">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">Operadores</h2>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button
          class="btn btn-sm btn-principal mr-2"
          data-toggle="collapse"
          href="#filtroscollapse"
          role="button"
          aria-expanded="false"
          aria-controls="filtroscollapse"
          @click="cargarFiltros"
        >
          <i class="bi-filter"></i> Filtros
        </button>
        <button
          class="btn btn-sm btn-principal mr-2"
          @click="getOperadoresExcel"
          title="Descargar listado completo"
        >
          <i class="bi-download"></i> Descargar listado completo
        </button>
        <button
          class="btn btn-sm btn-principal"
          data-toggle="tooltip"
          data-placement="top"
          title="Nuevo Operador"
          @click="showEdit({}, 'add')"
        >
          <i class="bi-plus"></i> Nuevo Operador
        </button>
      </div>
    </div>
    <div class="collapse mb-3" id="filtroscollapse">
      <div class="card card-body bg-light border-0 shadow-sm py-3 px-4">
        <div class="form-row align-items-end">
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="numero_corto_select">Por Número</label>
            <input
              type="text"
              class="form-control"
              id="numero_corto_select"
              name="numero_corto_sel"
              placeholder="Filtrar por número..."
              @keyup.enter="getOperadoresBusqueda()"
              v-model="numero_corto_sel"
              aria-label="Numero"
            />
          </div>
          <div class="form-group col-md-3 mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="enabled_select">Por Estado</label>
            <select
              class="form-control"
              v-model="activo_sel"
              name="atributo"
              aria-label="Activo"
              id="enabled_select"
            >
              <option selected value="null">Todos los estados</option>
              <option selected value="0">Inactivo</option>
              <option selected value="1">Activo</option>
            </select>
          </div>
          <div class="form-group col-auto mb-2">
            <button @click="getOperadoresBusqueda()" class="btn btn-info px-4">
              <i class="bi-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>

    <table
      class="table xtable-responsive table-striped xtable-fixed table-sm"
      v-if="operadoresBusqueda && operadoresBusqueda.data && operadoresBusqueda.data.length"
    >
      <thead>
        <tr>
          <th
            @click="orderByfield('id_operador')"
            class="tablesorter-header"
            :class="orderClass('id_operador')"
            scope="col"
            width="60"
          >
            Id
          </th>
          <th
            @click="orderByfield('numero_corto')"
            class="tablesorter-header"
            :class="orderClass('numero_corto')"
            scope="col"
          >
            Numero
          </th>
          <th
            @click="orderByfield('activo')"
            class="tablesorter-header"
            :class="orderClass('activo')"
            scope="col"
          >
            Estado
          </th>
          <th scope="col" width="110"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="operadorItem of operadoresBusqueda.data"
          v-bind:key="operadorItem.id_operador"
        >
          <th scope="row">{{ operadorItem.id_operador }}</th>
          <td>{{ operadorItem.numero_corto }}</td>
          <td
            :class="operadorItem.activo == 1 ? 'text-success' : 'text-danger'"
          >
            {{ operadorItem.activo == 1 ? "Activo" : "Inactivo" }}
          </td>
          <td>
            <nobr>
              <button
                type="button"
                class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Atributos del operador"
                @click="openAtributosModal(operadorItem)"
              >
                <small class="bi-bar-chart-steps"></small>
              </button>
              <button
                class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Editar Operador"
                @click="showEdit(operadorItem, 'edit')"
              >
                <small class="bi-pencil-fill"></small>
              </button>
              <button
                :class="
                  operadorItem.activo == 1
                    ? 'btn btn-warning btn-sm pt-0 pb-1'
                    : 'btn btn-success btn-sm pt-0 pb-1'
                "
                data-toggle="tooltip"
                data-placement="top"
                :title="operadorItem.activo == 1 ? 'Desactivar' : 'Activar'"
                @click="showEdit(operadorItem, 'toggle')"
              >
                <small
                  :class="operadorItem.activo == 1 ? 'bi-pause' : 'bi-play'"
                ></small>
              </button>
            </nobr>
          </td>
        </tr>
      </tbody>
    </table>
    <Paginador
      v-if="operadoresBusqueda && operadoresBusqueda.pages"
      :pages="operadoresBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <div
      v-if="
        !(
          operadoresBusqueda &&
          operadoresBusqueda.data &&
          operadoresBusqueda.data.length
        ) && post
      "
    >
      <div class="alert alert-info">
        No se obtubieron atributos con el criterio seleccionado.
      </div>
    </div>
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal Flotante de Atributos -->
    <div v-if="showAtributosModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
              <div class="modal-content shadow-lg border-0">
                <div class="modal-header bg-dark text-white">
                  <h5 class="modal-title">
                    <i class="bi bi-bar-chart-steps mr-2"></i>Atributos del Operador: <b>{{ selectedOperadorAtributos ? ((selectedOperadorAtributos.numero_corto ? ('Número: ' + selectedOperadorAtributos.numero_corto) : '') || ('ID: ' + selectedOperadorAtributos.id_operador)) : '' }}</b>
                  </h5>
                  <button type="button" class="close text-white" aria-label="Cerrar" @click="closeAtributosModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body p-3">
                  <Atributos
                    v-if="selectedOperadorAtributos"
                    :propOperador="selectedOperadorAtributos.id_operador"
                    :isModal="true"
                  />
                </div>
                <div class="modal-footer py-2">
                  <button type="button" class="btn btn-secondary btn-sm" @click="closeAtributosModal">
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-dialog-scrollable"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Operador</span>
                    <span v-if="editData.activo == 0"> Reactivar Operador</span>
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar Operador {{ editData.id_operador }}
                  </h5>
                  <h5 v-if="operation == 'add'" class="modal-title">
                    Nuevo Operador
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form
                    v-if="
                      operation == 'delete' ||
                      operation == 'edit' ||
                      operation == 'add'
                    "
                  >
                    <TextForm
                      title="Número"
                      name="numero_corto"
                      placeholder="Ej: 2025"
                      hint="Número corto visible para el usuario (dígitos numéricos)."
                      :value="editData.numero_corto || editData.numero"
                      @value="editData.numero_corto = $event; editData.numero = $event"
                      :errors="getError('numero_corto') || getError('numero')"
                    />
                  </form>

                  <p v-if="operation == 'toggle'">
                    Esta seguro de realizar esta acción?
                  </p>
                  <div
                    v-if="getError()"
                    class="alert alert-danger my-2"
                    role="alert"
                  >
                    <i class="bi bi-exclamation-triangle me-1"></i>
                    {{ getError() }}
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >

                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus()"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'"
                    @click="editOperador"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add'"
                    @click="agregarOperador"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import TextForm from "./forms/TextForm.vue";
import Atributos from "./Atributos.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";

export default {
  name: "Operadores",
  mixins: [tableSortMixin],

  components: {
    Paginador,
    TextForm,
    Atributos,
  },

  data() {
    return {
      showAtributosModal: false,
      selectedOperadorAtributos: null,
      success: null,
      error: null,
      operadoresBusqueda: null,
      id_integrador_sel: parseInt(localStorage.getItem("integrador")),
      numero_corto_sel: null,
      activo_sel: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: null,
      valor: null,
      id_operador: null,
    };
  },

  created() {
    this.getOperadoresBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"]),
  },
  methods: {
    cargarFiltros: function () {
      return Promise.resolve(null);
    },

    changePage: function (page) {
      this.page = page;
      this.getOperadoresBusqueda(false);
    },

    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getOperadoresBusqueda(false);
    },



    getOperadoresBusqueda: function (hideResult = true) {
      if (hideResult) this.operadoresBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      return axios
        .post(process.env.VUE_APP_API_URL + "operador/busqueda", {

          page: this.page,
          id_integrador: this.id_integrador_sel,
          numero_corto: this.numero_corto_sel,
          activo: this.activo_sel,
          order_by: { field: this.orderByField, order: this.orderByDirection },
        })
        .then((response) => {
          this.operadoresBusqueda = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    deleteOperador: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "operador/delete", {
          id_operador: this.editData.id_operador,
          activo: this.editData.activo == 1 ? 0 : 1,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar eliminar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getOperadoresBusqueda();
        });
    },
    editOperador: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "operador/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Operador actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getOperadoresBusqueda();
        });
    },
    openAtributosModal: function (item) {
      this.selectedOperadorAtributos = item;
      this.showAtributosModal = true;
    },

    closeAtributosModal: function () {
      this.showAtributosModal = false;
      this.selectedOperadorAtributos = null;
    },

    showEdit: function (item, operation) {
      this.cargarFiltros();
      this.errors = null;
      this.editData = Object.assign({}, item);
      this.showModal = true;
      this.operation = operation;
    },

    agregarOperador: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.id_integrador = this.id_integrador_sel;
      axios
        .post(process.env.VUE_APP_API_URL + "operador/new", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data;
          } else {
            const createdOp = (response.data && response.data.data) ? Object.assign({}, response.data.data) : {
              id_operador: response.data && (response.data.id_operador || response.data.id),
              numero_corto: this.editData.numero_corto || this.editData.numero,
              activo: this.editData.activo !== undefined ? this.editData.activo : 1,
            };
            if (!createdOp.id_operador && response.data && response.data.id_operador) {
              createdOp.id_operador = response.data.id_operador;
            }
            if (!createdOp.numero_corto) {
              createdOp.numero_corto = this.editData.numero_corto || this.editData.numero;
            }

            this.showModal = false;
            this.operation = null;
            this.editData = null;

            this.openAtributosModal(createdOp);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getOperadoresBusqueda();
        });
    },


  getOperadoresExcel: function () {
    startAsyncExport("operador", {
      id_integrador: this.id_integrador_sel,
      order_by: {
        field: this.orderByField,
        order: this.orderByDirection,
      },
    }, "Operadores");
  },

    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "operador/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Operador actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getOperadoresBusqueda();
        });
    },
    closeModal() {
      this.showModal = false;
      this.operation = null;
      this.editData = null;
    },
    getError(name) {
      if (name) {
        return this.errors && this.errors.errors && this.errors.errors[name]
          ? this.errors.errors[name]
          : null;
      }
      if (!this.errors) return null;
      if (typeof this.errors === "string") return this.errors;
      return this.errors.error || this.errors.message || JSON.stringify(this.errors);
    },

  },
};
</script>

<style scoped>
.tablesorter-header {
  position: relative;
  padding-right: 22px;
}

.tablesorter-header::before,
.tablesorter-header::after {
  position: absolute;
  right: 0.75em;
  font-family: "bootstrap-icons";
  opacity: 0.3;
  font-size: 0.8em;
}

.tablesorter-header::before {
  content: "\f235";
  top: calc(50% - 1.1em);
}

.tablesorter-header::after {
  content: "\f229";
  bottom: calc(50% - 1.1em);
}

.tablesorter-header.asc::before,
.tablesorter-header.desc::after {
  opacity: 1;
}
</style>
